module.exports = __webpack_public_path__ + "static/img/role.680f989.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/team/role.png
// module id = L/5o
// module chunks = 7